module.exports = __webpack_public_path__ + "static/media/Vector2.6d1c00fb.svg";